import { rest } from 'msw';

import { config } from '@/shared/api/axios';
import { delayTime } from '@/shared/mocks/handler';
import { buildMockDataExtractionResponse } from './response';

export const dataExtraction = [
  rest.get(`${config.baseURL}/touki/extraction/data`, (req, res, ctx) => {
    const companyInformationId = req.url.searchParams.get('companyInformationId');
    const response = buildMockDataExtractionResponse(companyInformationId);

    return res(ctx.delay(delayTime), ctx.status(200), ctx.json(response));
  }),
  rest.put(`${config.baseURL}/touki/extraction/data`, (req, res, ctx) => {
    // 204 No Content response for successful update
    return res(ctx.delay(delayTime), ctx.status(204));
  }),
  rest.get(`${config.baseURL}/touki/extraction/preview`, (req, res, ctx) => {
    const fileId = req.url.searchParams.get('fileId');
    return res(
      ctx.delay(delayTime),
      ctx.status(200),
      ctx.json({
        fileId: fileId ? Number(fileId) : 1,
        fileKey: `file_${fileId}`,
        fileName: `preview_${fileId}.pdf`,
        url: 'https://example.com/sample.pdf',
      }),
    );
  }),
];
